import { apiRequest } from "./apiClient"

// Permanently deletes the signed-in user's auth account; every user-owned row
// (and households they created) goes with it via DB cascades. A POST action
// under /api/account/ on purpose: that prefix is excluded from the offline
// outbox, so a deletion that failed offline can never replay later.
export function deleteAccount(): Promise<{ success: boolean }> {
  return apiRequest<{ success: boolean }>("/api/account/delete", { method: "POST" })
}
